import {ArchivedWorkflowContainer} from './components/archived-workflow-container';

export default {
    component: ArchivedWorkflowContainer
};
